import { render, staticRenderFns } from "./myIframe.vue?vue&type=template&id=10f67fb5&scoped=true"
import script from "./myIframe.vue?vue&type=script&lang=js"
export * from "./myIframe.vue?vue&type=script&lang=js"
import style0 from "./myIframe.vue?vue&type=style&index=0&id=10f67fb5&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10f67fb5",
  null
  
)

export default component.exports